import { Route, HashRouter as Router, Routes } from "react-router-dom";
import DefaultHome from "./screens/DefaultHome";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<DefaultHome />} />
      </Routes>
    </Router>
  );
}

export default App;
